import React, { Suspense } from 'react'
import MuiMenu from '@mui/material/Menu'
import MuiBox from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import MuiTypography from '@mui/material/Typography'
import Export from '../common/Icons/Export'
import { IconButton as MuiIconButton } from '@mui/material'
import Intercity from '../common/Icons/Intercity'

const getIcon = (icon) => {
  const MyIcon = React.lazy(async () => {
    try {
      return await import(`../common/Icons/${icon}.jsx`)
    } catch {
      return await import(`../common/Icons/Location.jsx`)
    }
  })
  return <MyIcon />
}
const MenuCard = ({ open, onClose, anchorEl, menuCardData }) => {
  const handleClick = (url, token) => {
    window.open(url + token)
  }

  const handleButtonClick = () => {
    window.open('https://www.intugine.com/')
  }

  const theme = useTheme()
  return (
    <MuiMenu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiList-root': {
          padding: '0px',
        },
        mt: 2,
      }}
    >
      <MuiBox
        sx={{
          minWidth: '280px',
          maxWidth: '350px',
          // margin: '0px 14px',
          // paddingTop: '26px',
          // pb: '20px',
          p: '26px 14px 20px 14px',
          borderBottom: `1px solid ${theme.palette.primary[200]}`,
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          flexWrap: 'wrap',
        }}
      >
        <Suspense fallback={<Intercity />}>
          {menuCardData?.map((item, i) => (
            <MuiBox
              key={i}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '75px',
                width: '100px',
              }}
            >
              <MuiIconButton
                onClick={() => {
                  handleClick(item?.url, item?.token)
                }}
                size="small"
              >
                {getIcon(item?.icon)}
              </MuiIconButton>
              <MuiTypography variant="body2" sx={{ mt: '4px' }}>
                {item?.name}
              </MuiTypography>
            </MuiBox>
          ))}
        </Suspense>
      </MuiBox>
      <MuiBox
        sx={{
          minWidth: '280px',
          maxWidth: '350px',
          // width: '240px',
          height: '64px',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& :hover': {
            backgroundColor: theme.palette.primary[50],
            cursor: 'pointer',
          },
        }}
      >
        <MuiTypography variant="body2">Learn more about Intugine</MuiTypography>
        <MuiIconButton onClick={handleButtonClick} size="small">
          <Export />
        </MuiIconButton>
      </MuiBox>
    </MuiMenu>
  )
}

export default MenuCard
